// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Column from "./column"
import _content from "../../../content/layouts/footer.json"

const ServicesColumn = ({ langKey }) => {
  const {
    OurServices,
    Strategy,
    Campaign,
    BrandContent,
    Ops,
    Training,
  } = _content[langKey]

  const content = [
    {
      paragraph: Ops,
      url: langKey === `en` ? `/amazon-agency/` : `/${langKey}/amazon-agency/`,
    },
    {
      paragraph: Strategy,
      url: langKey === `en` ? `/amazon-agency/` : `/${langKey}/amazon-agency/`,
    },
    {
      paragraph: Campaign,
      url: langKey === `en` ? `/amazon-agency/` : `/${langKey}/amazon-agency/`,
    },
    {
      paragraph: BrandContent,
      url: langKey === `en` ? `/amazon-agency/` : `/${langKey}/amazon-agency/`,
    },
    {
      paragraph: Training,
      url: langKey === `en` ? `/amazon-agency/` : `/${langKey}/amazon-agency/`,
    },
  ]
  const url = langKey === `en` ? `/amazon-agency` : `/${langKey}/amazon-agency/`
  return <Column title={OurServices} content={content} url={url} />
}

export default ServicesColumn
